import template from './client-edit-form.html';
import controller from './client-edit-form-controller';

const ClientEditFormComponent = {
    bindings: {
        client: '<',
        industryCodeList: '<',
        groupList: '<',
        relatedModels: '<',
        updateTree: '&'
    },
    controller,
    template
};

export default ClientEditFormComponent;



// WEBPACK FOOTER //
// ./app/components/client-edit/client-edit-form/client-edit-form-component.js